<div *ngIf="step == 0">
    <p class="mb-4">
        Your campaign was set to go live in less than 48 hours, if you want to launch it urgently
        please contact the Media connector support.
    </p>

    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button (click)="moveSteps(1)" class="btn btn-md btn-gray-500">proceed</button>
    </div>
</div>

<div *ngIf="step == 1">
    <p class="mb-4">Please mention the relaunch date</p>
    <mat-form-field class="form-group dark-input mb-2">
        <mat-label>Relaunch Date</mat-label>
        <input
            matInput
            [matDatepicker]="startDatePicker"
            [min]="minStartDate"
            [max]="endDate"
            [matDatepickerFilter]="dateFilter"
            [(ngModel)]="upcomingStatusDate"
            (dateChange)="onUpcomingStatusDateChanged($event.value)"
            name="cancelDate"
        />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>

    <div class="d-flex align-items-center justify-content-center">
        <button
            [disabled]="!isUpcomingDateWithinRange()"
            (click)="moveSteps(2)"
            class="btn btn-md btn-gray-500"
        >
            Ok
        </button>
    </div>
</div>

<div *ngIf="step == 2">
    <h6 class="montserrat-medium text-gray-500 mb-2">{{ getTitle() }}</h6>
    <p class="mb-4" *ngIf="getDescription()">
        {{ getDescription() }}
    </p>
    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button
            [disabled]="!canRelaunchCampaign() || (!isAdmin && !isUpcomingDateWithinRange())"
            (click)="relaunchCampaign()"
            class="btn btn-md btn-gray-500"
        >
            yes
        </button>
    </div>
</div>
